import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import './index.scss';
import WorkOrderCardUI from './WorkOrderCardUI';
import DraggableModal from '@/components/DraggableModal';
import RtcPlayer from '@/components/VideoPlayer/RtcPlayer';
import {
  addGlobalEventListener,
  removeGlobalEventListener,
} from '@/utils/emit';
import { RootState } from '@/redux/store';

const WorkOrderDrawer = ({ isDrawerOpen }: { isDrawerOpen: boolean }) => {
  const { issue, newCommon, controlBtn } = useSelector(
    (state: RootState) => state
  );
  const [videoModalInfo, setVideoModalInfo] = useState<any>({
    open: false,
    videoUrl: '',
    direction: '',
    vehicleName: '',
  });

  useEffect(() => {
    const cb = (data: any) => {
      setVideoModalInfo({ ...data });
    };
    addGlobalEventListener('CHANGE_ISSUE_VIDEO_MODAL', cb);
    return () => {
      removeGlobalEventListener('CHANGE_ISSUE_VIDEO_MODAL', cb);
    };
  }, []);

  return (
    <>
      <div className="workorder-drawer-container">
        <div className="workorder-drawer-title">
          <i className="title-icon"></i>
          <span>{`工单列表(${issue?.list?.length || 0})`}</span>
        </div>

        <div className="workorder-drawer-content">
          {issue?.list?.length > 0 ? (
            <>
              {issue?.list?.map((item: any) => {
                return (
                  <WorkOrderCardUI
                    isDrawerOpen={isDrawerOpen}
                    key={item.issueNumber}
                    info={item}
                    magnifyVehicleName={videoModalInfo.vehicleName}
                    takeOverUserName={issue.takeOverUserName}
                    takeOverCockpitNumber={issue.takeOverCockpitNumber}
                    cockpitNumber={newCommon.cockpitNumber}
                    LC_BUTTON_R2={controlBtn?.LC_BUTTON_R2}
                    LC_BUTTON_R3={controlBtn?.LC_BUTTON_R3}
                  />
                );
              })}
            </>
          ) : (
            <div className="no-workorder">
              <i className="no-workorder-icon"></i>
              <span>暂无工单</span>
            </div>
          )}
        </div>
      </div>

      {videoModalInfo.open && (
        <DraggableModal
          className="issue-video-modal"
          title={`实时视频：${videoModalInfo.direction}   车牌号：${videoModalInfo.vehicleName}`}
          onClose={() =>
            setVideoModalInfo({
              open: false,
              videoUrl: '',
              direction: '',
              vehicleName: '',
            })
          }
        >
          <RtcPlayer
            key={videoModalInfo.videoUrl}
            videoUrl={videoModalInfo.videoUrl}
            direction={videoModalInfo.direction!}
          />
        </DraggableModal>
      )}
    </>
  );
};

export default React.memo(WorkOrderDrawer);
